import { connect } from 'react-redux';
import { createSubmitAction } from '../../app/forms';
import { FormattedMessage } from 'react-intl';
import { getRegions, selectRegions } from '../../app/regions';
import { selectLocation } from '../locations';
import { withRouter } from 'react-router-dom';
import {routerActions} from 'react-router-redux';
import Alert from '../../../ui/Alert';
import Button from '../../../ui/Button';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../app/components/Spinner';
import UpdateAddressForm from '../forms/UpdateAddress';

import {
    UPDATE_LOCATION_SUBMIT,
    UPDATE_LOCATION_SUCCESS,
    UPDATE_LOCATION_FAILURE,
} from '../locations';

export class AddressbookEditor extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        location: ImmutablePropTypes.map.isRequired,
        regions: ImmutablePropTypes.map.isRequired,
    }

    componentWillMount() {
        this.props.dispatch(getRegions({}, { spinner: 'addressbook' }));
    }

    handleSubmitSuccess() {
        window.scrollTo(0, 0);
        this.props.dispatch(routerActions.push("/addressbook"));
    }

    handleSubmitFailure() {
        window.scrollTo(0, 0);
    }

    render() {
        const { location, regions } = this.props;
        let initialValues = location;

        if (location && regions) {
            const region = regions.get(location.get('address').get('regionId'));
            if (region) {
                const address = location.get('address').set('region', region.get('name'));
                initialValues = location.set('address', address);
            }
        }

        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h1>
                        <FormattedMessage id='frontend.addressbook.headline.edit_address' />
                    </h1>
                </Page.Section>
                <Page.Section>
                    <Page.Content>
                        <Alert type='warning'>
                            <FormattedMessage
                                id='frontend.form_addressbook.text.edit_address_hint'
                            />
                        </Alert>
                        <UpdateAddressForm.Component
                            initialValues={initialValues}
                            regions={regions}
                            onSubmit={createSubmitAction(
                                UPDATE_LOCATION_SUBMIT,
                                UPDATE_LOCATION_SUCCESS,
                                UPDATE_LOCATION_FAILURE
                            )}
                            onSubmitSuccess={this.handleSubmitSuccess.bind(this)}
                            onSubmitFail={this.handleSubmitFailure}
                        />
                        <br />

                        <Button link to='/addressbook' block>
                            <FormattedMessage id='frontend.form_selector_shipping.button.cancel' />
                        </Button>
                    </Page.Content>
                    <IsSpinning id='addressbook'>
                        <Spinner />
                    </IsSpinning>
                </Page.Section>
            </Page.Body>
        );
    }
}

export default withRouter(connect((state, props) => ({
    location: selectLocation(state, props.match.params.location),
    regions: selectRegions(state),
}))(AddressbookEditor));
